var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 flexCenter links-Box"},[_c('div',{staticClass:"dsMainBox dsMainBoxda"},_vm._l((_vm.list),function(item){return _c('a',{key:item.id,attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.img,"alt":""}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }